import { List, Paper, Typography } from "@mui/material";
import { SharedPatientInvite } from "../center/invite";
import { useState } from "react";
import HandshakeIcon from '@mui/icons-material/Handshake';
import AlertDialog from "../../components/atoms/Popup";
import { acceptSharedPatient, rejectSharedPatient } from "../../adapters/Firebase";
import { useTranslation } from "../../contexts/TranslationContext";
import SharedPatient from "./SharedPatient";

interface SharedPatientsProps {
    invitations: SharedPatientInvite[]
}

function SharedPatients(props: SharedPatientsProps) {
	const { translate } = useTranslation();
    const [invitationError, setInvitationError] = useState<string | null>(null);

    async function handleAcceptSharedPatient(invitation: SharedPatientInvite) {
        const result = await acceptSharedPatient(invitation.patientID);
        if (result.result !== 200) {
            setInvitationError(() => result.message);
        }
    }

    async function handleRejectSharedPatient(invitation: SharedPatientInvite) {
        const result = await rejectSharedPatient(invitation.patientID);
        if (result.result !== 200) {
            setInvitationError(() => result.message);
        }
    }

    return (
        <>
            <Typography variant="h5" gutterBottom noWrap>
                {translate("[patient_shared_title]")}
            </Typography>
            <Typography variant="body2" gutterBottom>
                {translate("[patient_shared_description]")}
            </Typography>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <List>
                    {
                        Array.from(props.invitations).map((invitation: SharedPatientInvite, index: number) => (
                            <SharedPatient
                                invitation={invitation}
                                key={index}
                                icon={<HandshakeIcon color="secondary" />}
                                onAccept={() => handleAcceptSharedPatient(invitation)}
                                onCancel={() => handleRejectSharedPatient(invitation)} />
                        ))
                    }
                </List>
            </Paper>

            < AlertDialog
                open={!!invitationError}
                title={translate("[center_invitationerror_title]")}
                cancelTitle={translate("[center_accept]")}
                onCancel={() => setInvitationError(() => null)} >
                {translate(invitationError!)}
            </AlertDialog>

        </>
    );
}

export default SharedPatients;